import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export function PdfUploadStep({
  onFile,
  uploading,
  hint = "Arraste o PDF aqui ou",
}: {
  onFile: (file: File) => void | Promise<void>;
  uploading: boolean;
  hint?: string;
}) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFile = (file: File) => {
    if (file.type !== "application/pdf") {
      toast.error("Selecione um arquivo PDF");
      return;
    }
    void onFile(file);
  };

  return (
    <div
      className={cn(
        "rounded-[13px] border border-dashed p-8 text-center transition-colors",
        dragOver ? "border-primary bg-accent" : "border-border bg-muted",
      )}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        const f = e.dataTransfer.files[0];
        if (f) handleFile(f);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
    >
      {uploading ? (
        <div className="flex flex-col items-center gap-2 py-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Enviando PDF...</p>
        </div>
      ) : (
        <>
          <Upload className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />
          <p className="mb-3 text-[13px] text-muted-foreground">{hint}</p>
          <input
            ref={fileInputRef}
            type="file"
            accept="application/pdf"
            className="hidden"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) handleFile(f);
            }}
          />
          <Button
            type="button"
            variant="outline"
            className="h-9 rounded-[9px] text-[12.5px] font-semibold"
            onClick={() => fileInputRef.current?.click()}
          >
            Selecionar arquivo
          </Button>
        </>
      )}
    </div>
  );
}
